/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AssetManagementControllerImportAssets$Params {

/**
 * true: simula la procedura senza scrivere nulla
 */
  dry_run?: string;

/**
 * true: consente di aggiornare anche asset a magazzino
 */
  include_warehouse_assets?: string;
      body: {
'File'?: Blob;
}
}

export function assetManagementControllerImportAssets(http: HttpClient, rootUrl: string, params: AssetManagementControllerImportAssets$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, assetManagementControllerImportAssets.PATH, 'post');
  if (params) {
    rb.query('dry_run', params.dry_run, {});
    rb.query('include_warehouse_assets', params.include_warehouse_assets, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

assetManagementControllerImportAssets.PATH = '/asset-management/import';
